import { createFileRoute, redirect } from '@tanstack/react-router';

// The portal root is /admin (kept identical to the apps/web surface so the
// copied components' navigate() targets work verbatim). / just forwards.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin' });
  },
});
